module.exports = __webpack_public_path__ + "img/logo.51ae3a18.png";